import { createApp } from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import { deleteTenant, getLocale } from '@/utils'
import store from './store'

const responseMessages = value => {
  if (!value) { return [] }
  if (Array.isArray(value)) { return value }
  if (typeof value === 'object') { return Object.values(value).flat() }
  return [value]
}

const staleTenantMessages = error => {
  const data = error.response?.data || {}
  return [...responseMessages(data.errors), ...responseMessages(data.messages)].map(message => `${message}`)
}

const isStaleTenantError = error => {
  return error.response?.status === 404 && staleTenantMessages(error).some(message => message.includes("Couldn't find Tenant"))
}

const canRetryWithoutTenant = config => {
  const url = config?.url || ''
  return config?.method === 'get' && (
    url.includes('/registrations') ||
    url.includes('/analytics/') ||
    url.includes('/ai_analytics/')
  )
}

axios.interceptors.request.use(config => {
  config.headers['Accept-Language'] = getLocale()
  return config
})

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      store.dispatch('logout')
      router.push({ name: 'login' })
    }

    if (isStaleTenantError(error)) {
      deleteTenant()

      if (!error.config?._retryWithoutTenant && canRetryWithoutTenant(error.config)) {
        const config = {
          ...error.config,
          _retryWithoutTenant: true,
          headers: { ...error.config.headers }
        }
        delete config.headers['X-TENANT-ID']
        return axios(config)
      }
    }

    return Promise.reject(error)
  }
)
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import i18n from './plugins/i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import globalMixin from '@/mixin'
import { register } from '@/shared-components'
import filters from '@/filters'

loadFonts()

const app = createApp(App)
app.mixin(globalMixin)
app.use(i18n)
app.use(router)
app.use(store)
app.use(vuetify(i18n))
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas) // Include needed solid icons
library.add(far) // Include needed regular icons

register(app)
filters(app)
app.mount('#app')
